import * as React from "react";
const SvgLayersTwo01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.537 13.575a1.035 1.035 0 0 1 .926 1.851l-9.643 4.82c-.077.04-.292.158-.537.204-.187.035-.38.035-.566 0-.245-.046-.46-.165-.537-.203l-9.643-4.82a1.035 1.035 0 0 1 .926-1.852L12 18.342zM12.142 3.53l.141.02.176.045c.167.054.303.128.361.157l9.643 4.822a1.036 1.036 0 0 1 0 1.851l-9.643 4.82c-.077.04-.292.158-.537.204-.187.035-.38.035-.566 0-.245-.046-.46-.165-.537-.203l-9.643-4.82a1.036 1.036 0 0 1 0-1.852l9.643-4.822c.077-.038.292-.157.537-.203l.141-.02q.143-.012.284 0M4.314 9.499 12 13.342 19.685 9.5 12 5.658z"
}));
export default SvgLayersTwo01;
//# sourceMappingURL=LayersTwo01.js.map